/**
 * MuiCssBaseline
 * https://lumahealth.clickup.com/t/864egg6k5
 *
 * Styles:
 *
 * - [Proto](https://mui.com/material-ui/customization/typography/#self-hosted-fonts)
 */
const MuiCssBaseline = {
  styleOverrides: `
a {
  color: #313199;
}

@font-face {
font-family: 'halyard-display';
src: url('https://use.typekit.net/af/272149/00000000000000007735adb1/30/l?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=n3&v=3')
  format('woff2'),
url('https://use.typekit.net/af/272149/00000000000000007735adb1/30/d?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=n3&v=3')
  format('woff'),
url('https://use.typekit.net/af/272149/00000000000000007735adb1/30/a?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=n3&v=3')
  format('opentype');
font-display: auto;
font-style: normal;
font-weight: 300;
font-stretch: normal;
}

@font-face {
font-family: 'halyard-display';
src: url('https://use.typekit.net/af/6bc5ed/00000000000000007735adb4/30/l?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=i3&v=3')
  format('woff2'),
url('https://use.typekit.net/af/6bc5ed/00000000000000007735adb4/30/d?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=i3&v=3')
  format('woff'),
url('https://use.typekit.net/af/6bc5ed/00000000000000007735adb4/30/a?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=i3&v=3')
  format('opentype');
font-display: auto;
font-style: italic;
font-weight: 300;
font-stretch: normal;
}

@font-face {
font-family: 'halyard-display';
src: url('https://use.typekit.net/af/7ab864/00000000000000007735adb2/30/l?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=i4&v=3')
  format('woff2'),
url('https://use.typekit.net/af/7ab864/00000000000000007735adb2/30/d?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=i4&v=3')
  format('woff'),
url('https://use.typekit.net/af/7ab864/00000000000000007735adb2/30/a?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=i4&v=3')
  format('opentype');
font-display: auto;
font-style: italic;
font-weight: 400;
font-stretch: normal;
}

@font-face {
font-family: 'halyard-display';
src: url('https://use.typekit.net/af/7e8d8a/00000000000000007735adb8/30/l?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=n4&v=3')
  format('woff2'),
url('https://use.typekit.net/af/7e8d8a/00000000000000007735adb8/30/d?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=n4&v=3')
  format('woff'),
url('https://use.typekit.net/af/7e8d8a/00000000000000007735adb8/30/a?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=n4&v=3')
  format('opentype');
font-display: auto;
font-style: normal;
font-weight: 400;
font-stretch: normal;
}

@font-face {
font-family: 'halyard-display';
src: url('https://use.typekit.net/af/f9d419/00000000000000007735adbb/30/l?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=i5&v=3')
  format('woff2'),
url('https://use.typekit.net/af/f9d419/00000000000000007735adbb/30/d?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=i5&v=3')
  format('woff'),
url('https://use.typekit.net/af/f9d419/00000000000000007735adbb/30/a?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=i5&v=3')
  format('opentype');
font-display: auto;
font-style: italic;
font-weight: 500;
font-stretch: normal;
}

@font-face {
font-family: 'halyard-display';
src: url('https://use.typekit.net/af/165087/00000000000000007735adc0/30/l?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=n5&v=3')
  format('woff2'),
url('https://use.typekit.net/af/165087/00000000000000007735adc0/30/d?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=n5&v=3')
  format('woff'),
url('https://use.typekit.net/af/165087/00000000000000007735adc0/30/a?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=n5&v=3')
  format('opentype');
font-display: auto;
font-style: normal;
font-weight: 500;
font-stretch: normal;
}

@font-face {
font-family: 'halyard-display';
src: url('https://use.typekit.net/af/e51fb7/00000000000000007735adc9/30/l?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=n7&v=3')
  format('woff2'),
url('https://use.typekit.net/af/e51fb7/00000000000000007735adc9/30/d?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=n7&v=3')
  format('woff'),
url('https://use.typekit.net/af/e51fb7/00000000000000007735adc9/30/a?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=n7&v=3')
  format('opentype');
font-display: auto;
font-style: normal;
font-weight: 700;
font-stretch: normal;
}

@font-face {
font-family: 'halyard-display';
src: url('https://use.typekit.net/af/8ac9a7/00000000000000007735adcc/30/l?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=i7&v=3')
  format('woff2'),
url('https://use.typekit.net/af/8ac9a7/00000000000000007735adcc/30/d?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=i7&v=3')
  format('woff'),
url('https://use.typekit.net/af/8ac9a7/00000000000000007735adcc/30/a?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=i7&v=3')
  format('opentype');
font-display: auto;
font-style: italic;
font-weight: 700;
font-stretch: normal;
}

@font-face {
font-family: 'halyard-text';
src: url('https://use.typekit.net/af/e40556/00000000000000007735adbc/30/l?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=n3&v=3')
  format('woff2'),
url('https://use.typekit.net/af/e40556/00000000000000007735adbc/30/d?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=n3&v=3')
  format('woff'),
url('https://use.typekit.net/af/e40556/00000000000000007735adbc/30/a?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=n3&v=3')
  format('opentype');
font-display: auto;
font-style: normal;
font-weight: 300;
font-stretch: normal;
}

@font-face {
font-family: 'halyard-text';
src: url('https://use.typekit.net/af/06aac1/00000000000000007735adbe/30/l?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=i3&v=3')
  format('woff2'),
url('https://use.typekit.net/af/06aac1/00000000000000007735adbe/30/d?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=i3&v=3')
  format('woff'),
url('https://use.typekit.net/af/06aac1/00000000000000007735adbe/30/a?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=i3&v=3')
  format('opentype');
font-display: auto;
font-style: italic;
font-weight: 300;
font-stretch: normal;
}

@font-face {
font-family: 'halyard-text';
src: url('https://use.typekit.net/af/a7393c/00000000000000007735adc2/30/l?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=n4&v=3')
  format('woff2'),
url('https://use.typekit.net/af/a7393c/00000000000000007735adc2/30/d?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=n4&v=3')
  format('woff'),
url('https://use.typekit.net/af/a7393c/00000000000000007735adc2/30/a?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=n4&v=3')
  format('opentype');
font-display: auto;
font-style: normal;
font-weight: 400;
font-stretch: normal;
}

@font-face {
font-family: 'halyard-text';
src: url('https://use.typekit.net/af/aec1c4/00000000000000007735adc5/30/l?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=i4&v=3')
  format('woff2'),
url('https://use.typekit.net/af/aec1c4/00000000000000007735adc5/30/d?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=i4&v=3')
  format('woff'),
url('https://use.typekit.net/af/aec1c4/00000000000000007735adc5/30/a?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=i4&v=3')
  format('opentype');
font-display: auto;
font-style: italic;
font-weight: 400;
font-stretch: normal;
}

@font-face {
font-family: 'halyard-text';
src: url('https://use.typekit.net/af/b681e0/00000000000000007735adce/30/l?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=i6&v=3')
  format('woff2'),
url('https://use.typekit.net/af/b681e0/00000000000000007735adce/30/d?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=i6&v=3')
  format('woff'),
url('https://use.typekit.net/af/b681e0/00000000000000007735adce/30/a?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=i6&v=3')
  format('opentype');
font-display: auto;
font-style: italic;
font-weight: 600;
font-stretch: normal;
}

@font-face {
font-family: 'halyard-text';
src: url('https://use.typekit.net/af/2ed20c/00000000000000007735add1/30/l?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=n6&v=3')
  format('woff2'),
url('https://use.typekit.net/af/2ed20c/00000000000000007735add1/30/d?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=n6&v=3')
  format('woff'),
url('https://use.typekit.net/af/2ed20c/00000000000000007735add1/30/a?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=n6&v=3')
  format('opentype');
font-display: auto;
font-style: normal;
font-weight: 600;
font-stretch: normal;
}

@font-face {
font-family: 'halyard-text';
src: url('https://use.typekit.net/af/8c6bd4/00000000000000007735add4/30/l?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=n7&v=3')
  format('woff2'),
url('https://use.typekit.net/af/8c6bd4/00000000000000007735add4/30/d?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=n7&v=3')
  format('woff'),
url('https://use.typekit.net/af/8c6bd4/00000000000000007735add4/30/a?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=n7&v=3')
  format('opentype');
font-display: auto;
font-style: normal;
font-weight: 700;
font-stretch: normal;
}

@font-face {
font-family: 'halyard-text';
src: url('https://use.typekit.net/af/1c6519/00000000000000007735add6/30/l?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=i7&v=3')
  format('woff2'),
url('https://use.typekit.net/af/1c6519/00000000000000007735add6/30/d?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=i7&v=3')
  format('woff'),
url('https://use.typekit.net/af/1c6519/00000000000000007735add6/30/a?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=i7&v=3')
  format('opentype');
font-display: auto;
font-style: italic;
font-weight: 700;
font-stretch: normal;
}
  `
};
export default MuiCssBaseline;